import React from 'react';
import { Chip, Button } from "@mui/material";

// columns内で使用されるユーティリティ
const statusChip = (value) => {
  if (!value) return "—";
  const map = { complete: "success", in_progress: "warning", not_yet: "default" };
  return <Chip size="small" color={map[value] ?? "default"} label={value} />;
};

const fmtAuthor = (r) => {
  if (!r) return "";
  const ln = r.last_name || "";
  const fn = r.first_name || "";
  return `${ln}${ln && fn ? ", " : ""}${fn}`;
};

export const publicationsColumns = ({ onEdit }) => {
  return [
    {
      field: "__actions",
      headerName: "Actions",
      width: 96,
      sortable: false,
      filterable: false,
      renderCell: (p) => (
        <Button size="small" variant="outlined" onClick={() => onEdit?.(p?.row)}>
          Edit
        </Button>
      ),
      headerClassName: "col-actions",
      cellClassName: "col-actions",
    },
    {
      field: "authors",
      headerName: "Authors",
      width: 260,
      sortable: false, // 複雑なソートはサーバーサイドで
      valueGetter: (p) => p?.row?.authorsText || "", // normalizeで設定したプロパティ
      renderCell: (p) =>
        (p?.row?.authors || []).length ? (
          <ol style={{ margin: 0, paddingInlineStart: 18 }}>
            {p.row.authors.map((a, i) => (
              <li key={a?.id || i}>{fmtAuthor(a)}</li>
            ))}
          </ol>
        ) : "—",
    },
    {
      field: "title_english",
      headerName: "Title (English)",
      flex: 1.2,
      minWidth: 260,
      sortable: false,
      renderCell: (p) => (
        <span dangerouslySetInnerHTML={{ __html: p?.row?.titleEnglishHtml || "" }} />
      ),
    },
    {
      field: "title_original",
      headerName: "Title (Original)",
      flex: 1,
      minWidth: 240,
      sortable: false,
      renderCell: (p) => (
        <span dangerouslySetInnerHTML={{ __html: p?.row?.titleOriginalHtml || "" }} />
      ),
    },
    {
      field: "journal_name", // ビューから取得
      headerName: "Journal",
      width: 200,
      valueGetter: (p) => p?.row?.journalName || "",
      renderCell: (p) => <i>{p?.row?.journalName || "—"}</i>,
    },
    {
      field: "doi",
      headerName: "DOI",
      width: 180,
      renderCell: (p) =>
        p?.row?.doi ? (
          <a
            href={`https://doi.org/${p.row.doi}`}
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#7dd3fc",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {p.row.doi}
          </a>
        ) : "—",
    },
    { field: "volume", headerName: "Vol.", width: 70 },
    { field: "number", headerName: "No.", width: 70 },
    { field: "article_id", headerName: "Article ID", width: 100 },
    { field: "page", headerName: "Pages", width: 90 },
    {
      field: "publication_date",
      headerName: "Date",
      width: 110,
      valueGetter: (p) => (p?.row?.publication_date || "").slice(0, 10),
    },
    {
      field: "is_open_access",
      headerName: "Open",
      width: 72,
      renderCell: (p) =>
        p?.row?.is_open_access ? <Chip size="small" color="success" label="Open" /> : "—",
    },
    {
      field: "scientific_name_status",
      headerName: "Sci. Name?",
      width: 140,
      renderCell: (p) => statusChip(p?.row?.scientific_name_status),
    },
    {
      field: "taxonomic_act_status",
      headerName: "Tax. Act?",
      width: 130,
      renderCell: (p) => statusChip(p?.row?.taxonomic_act_status),
    },
    {
      field: "distribution_status",
      headerName: "Dist.?",
      width: 110,
      renderCell: (p) => statusChip(p?.row?.distribution_status),
    },
    {
      field: "ecological_data_status",
      headerName: "Ecol.?",
      width: 110,
      renderCell: (p) => statusChip(p?.row?.ecological_data_status),
    },
  ];
};
